export default {
  isLoading: state => state.loading,
  getLoading: state => state.loading,
  getLoadingMessage: state => state.loadingMessage,
  getStatus: state => state.status,
  getMessage: state => state.message,
  getErrorCode: state => state.errorCode,
};



// WEBPACK FOOTER //
// ./src/stores/Notification/getters/index.js